import { all, call, takeLatest, put, fork } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import api from '../../../services/api';
import {
  Creators as BonusGroupActions,
  Types as BonusGroupTypes,
} from '../../reducers/bonus_group';

import {
  Creators as RefreshActions,
} from '../../reducers/refresh';

function* listBonusGroup({ payload }) {
  try {
    const { data } = yield call(
      api.get,
      `/admin/bonus_group?page=${payload?.page}&bonus=${payload?.bonus}&name=${payload?.name}`
    );
    yield put(BonusGroupActions.setUpdateBonusGroup(false));
    yield put(BonusGroupActions.getBonusGroupListRequestSuccess(data));
    // toast.info("Success", {
    //   position: toast.POSITION.BOTTOM_CENTER
    // });

  } catch (error) {
    if (error?.response?.status === 401) {
      yield put(RefreshActions.setAlertModalExperedLogin(true));
    } else {
      yield put(BonusGroupActions.getBonusGroupListRequestFail(error?.response?.data));
      toast.info(`${JSON.stringify(error?.response?.data)}`, {
        position: toast.POSITION.BOTTOM_CENTER
      });
    }
  }
}

function* addBonusGroup({ payload }) {
  try {
    yield call(api.post, '/admin/bonus_group', payload);
    yield put(BonusGroupActions.setUpdateBonusGroup(true));
    yield put(BonusGroupActions.postBonusGroupAddRequestSuccess());
    toast.success("Salvo com sucesso", {
      position: toast.POSITION.BOTTOM_CENTER
    });

  } catch (error) {
    if (error?.response?.status === 401) {
      yield put(RefreshActions.setAlertModalExperedLogin(true));
    } else {
      yield put(BonusGroupActions.postBonusGroupAddRequestFail(error?.response?.data));
      toast.info(`${JSON.stringify(error?.response?.data)}`, {
        position: toast.POSITION.BOTTOM_CENTER
      });
    }
  }
}

function* editBonusGroup({ payload }) {
  console.log('payload', payload)
  try {
    yield call(api.put, `/admin/bonus_group/${payload?.id}`, payload);
    // console.log('data edit', data)
    yield put(BonusGroupActions.setUpdateBonusGroup(true));
    yield put(BonusGroupActions.putBonusGroupEditRequestSuccess());
    toast.success("Salvo com sucesso", {
      position: toast.POSITION.BOTTOM_CENTER
    });

  } catch (error) {
    if (error?.response?.status === 401) {
      yield put(RefreshActions.setAlertModalExperedLogin(true));
    } else {
      yield put(BonusGroupActions.putBonusGroupEditRequestFail(error?.response?.data));
      toast.info(`${JSON.stringify(error?.response?.data)}`, {
        position: toast.POSITION.BOTTOM_CENTER
      });
    }
  }
}

function* deleteBonusGroup({ payload }) {
  try {
    yield call(api.delete, `/admin/bonus_group/${payload?.id}`);
    // console.log('data store', data)
    yield put(BonusGroupActions.setUpdateBonusGroup(true));
    yield put(BonusGroupActions.postBonusGroupAddRequestSuccess());
    toast.success("Deletado com sucesso", {
      position: toast.POSITION.BOTTOM_CENTER
    });

  } catch (error) {
    if (error?.response?.status === 401) {
      yield put(RefreshActions.setAlertModalExperedLogin(true));
    } else {
      yield put(BonusGroupActions.deleteBonusGroupDelRequestFail(error?.response?.data));
      toast.info(`${JSON.stringify(error?.response?.data)}`, {
        position: toast.POSITION.BOTTOM_CENTER
      });
    }
  }
}

export function* listBonusGroupWatcher() {
  yield takeLatest(BonusGroupTypes.GET_BONUSGROUP_LIST_REQUEST, listBonusGroup);
}

export function* addBonusGroupWatcher() {
  yield takeLatest(BonusGroupTypes.POST_BONUSGROUP_ADD_REQUEST, addBonusGroup);
}

export function* editBonusGroupWatcher() {
  yield takeLatest(BonusGroupTypes.PUT_BONUSGROUP_EDIT_REQUEST, editBonusGroup);
}

export function* deleteBonusGroupWatcher() {
  yield takeLatest(BonusGroupTypes.DELETE_BONUSGROUP_DEL_REQUEST, deleteBonusGroup);
}

export default function* rootSaga() {
  yield all([
    fork(listBonusGroupWatcher),
    fork(addBonusGroupWatcher),
    fork(editBonusGroupWatcher),
    fork(deleteBonusGroupWatcher),
  ]);
}
